import React from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  makeStyles,
} from "@material-ui/core";
import { Box } from "common";

const useStyles = makeStyles({
  tableRightBorder: {
    "& .MuiTableCell-body": {
      borderRight: "1px solid rgba(224, 224, 224, 1)",
    },
    "& .MuiTableCell-body:last-child": {
      borderRight: "none",
    },
  },
  tabelHead: {
    backgroundColor: "#bbdefb",
    "& .MuiTableCell-root": {
      color: "#1a237e",
      fontSize: "14px",
      fontWeight: 600,
    },
  },
});

const GiftHelp = () => {
  const { tableRightBorder, tabelHead } = useStyles();
  const freeGiftRules = [
    {
      id: 1,
      parentProduct: ["Smartphone"],
      giftProduct: ["Adapter"],
      description: "If customer buys Smartphone, they get Adapter free.",
      examples: [
        "QTY 1 Smartphone → QTY 1 Adapter",
        "QTY 3 Smartphones → QTY 3 Adapters",
      ],
    },
    {
      id: 2,
      parentProduct: ["Smartphone", "Tablet"],
      giftProduct: ["Adapter", "Charging Cable"],
      description:
        "If customer buys Smartphone or Tablet, they get Adapter + Charging Cable free.",
      examples: [
        "QTY 1 Smartphone → QTY 1 Adapter + QTY 1 Cable",
        "QTY 1 Smartphone + QTY 1 Tablet → QTY 2 Adapters + QTY 2 Cables",
      ],
    },
    {
      id: 3,
      parentProduct: ["Smartphone", "Tablet", "iPad"],
      giftProduct: ["Adapter", "Charging Cable", "Screen Guard"],
      description:
        "If customer buys Smartphone or Tablet or iPad, they get Adapter + Charging Cable + Screen Guard free.",
      examples: [
        "QTY 1 Smartphone → QTY 1 Adapter + QTY 1 Cable + QTY 1 Screen Guard",
        "QTY 1 Smartphone + QTY 1 Tablet + QTY 1 iPad → QTY 3 Adapters + QTY 3 Cables + QTY 3 Screen Guards",
      ],
    },
  ];
  const renderWithOperator = (items: string[], operator: string) => {
    return items.map((item, index) => (
      <React.Fragment key={item}>
        {item}
        {index < items.length - 1 && (
          <>
            {" "}
            <strong>{operator}</strong>{" "}
          </>
        )}
      </React.Fragment>
    ));
  };

  return (
    <Table
      className={tableRightBorder}
      style={{ border: "1px solid rgba(224, 224, 224, 1)" }}
    >
      <TableHead>
        <TableRow className={tabelHead}>
          <TableCell align="left">Combination</TableCell>
          <TableCell align="left">Parent Product</TableCell>
          <TableCell align="left">Gift Product</TableCell>
          <TableCell align="left">What It Means</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {freeGiftRules?.map((rule) => (
          <TableRow key={rule.id}>
            <TableCell component="th" scope="row">
              {rule.id}
            </TableCell>
            <TableCell align="left">
              {renderWithOperator(rule.parentProduct, "OR")}
            </TableCell>
            <TableCell align="left">
              {renderWithOperator(rule.giftProduct, "AND")}
            </TableCell>
            <TableCell align="left">
              If customer buys{" "}
              <strong>{renderWithOperator(rule.parentProduct, "or")}</strong>,
              they get{" "}
              <strong>{renderWithOperator(rule.giftProduct, "+")}</strong> free.
              <Box mt={1} mb={1}>
                Example:
              </Box>
              <ol>
                {rule.examples.map((example, index) => (
                  <li key={index} style={{ fontWeight: 600 }}>
                    {example}
                  </li>
                ))}
              </ol>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default GiftHelp;
